goog.provide('el8.uiwidget.FormGuide');

goog.require('el8.template.uiwidget.FormGuide');


/**
 * This is something used by the onboarding (www.secure.elationemr.com)
 * app to walk the user through a series of forms
 */
el8.uiwidget.FormGuide = function(spec) {

    this._navContainer = spec.navContainer;
    this._formContainer = spec.formContainer;
    this._start = spec.start;

    this._errorContentFn = spec.errorContentFn || null;

    this._forms = {};

    this._names = [];
    this._currShowing = null;
};

el8.uiwidget.FormGuide.prototype.init = function() {
    return this;
};

el8.uiwidget.FormGuide.prototype.registerForm = function(spec) {
    this._navContainer.append(
        el8.template.uiwidget.FormGuide.navEntry(spec)
    );
    var formEntry = $(el8.template.uiwidget.FormGuide.formEntry(spec));
    this._formContainer.append(formEntry);
    if (spec.createFormFn) {
        this._forms[spec.name] = spec.createFormFn(this, formEntry);
    }
    this._names.push(spec.name);
};


/******************
 * Form Navigation
 ******************/
el8.uiwidget.FormGuide.prototype.start = function() {
    this.show(this._start, true);
};

el8.uiwidget.FormGuide.prototype.show = function(name, fresh) {
    this.historyShow.apply(this, arguments);
    if (typeof(window.history.pushState) === 'function') {
        window.history.pushState({name: name}, '', '?step='+name);
    }
};

el8.uiwidget.FormGuide.prototype.historyShow = function(name, fresh) {  // called when use browser back/forward
    this._currShowing = name;
    this.hideAll();

    $('.form-guide-entry[data-name="'+name+'"]', this._formContainer).show();
    $('.form-guide-nav[data-name="'+name+'"]', this._navContainer).addClass('el8EmphasisText');

    if (this._forms[name]) { this._forms[name].render(fresh); }
};

el8.uiwidget.FormGuide.prototype.hideAll = function() {
    $('.form-guide-error', this._formContainer).hide();
    $('.form-guide-entry', this._formContainer).hide();
    $('.form-guide-nav', this._navContainer).removeClass('el8EmphasisText');
};

el8.uiwidget.FormGuide.prototype.moveTo = function(name, force, fresh) {
    if (this._currShowing && this._forms[this._currShowing]) {
        if (!force) {
            // If there's a form currently showing, only move off it
            // if it's valid
            if (this._forms[this._currShowing].isValid()) {
                this.show(name, fresh);
            }
        } else {
            this.show(name, fresh);
        }
    } else {
        this.show(name, fresh);
    }
};

el8.uiwidget.FormGuide.prototype.next = function(name) {
    var nextName = this.getNextName(name);
    if (nextName) { this.moveTo(nextName); }
};

el8.uiwidget.FormGuide.prototype.prev = function(name) {
    var prevName = this.getPrevName(name);
    // Going backwards, force=true
    if (prevName) { this.moveTo(prevName, true); }
};

el8.uiwidget.FormGuide.prototype.getNextName = function(name) {
    var index = this._names.indexOf(name);
    if (this._names.length > index + 1) {
        return this._names[index + 1];
    }
    return null;
};

el8.uiwidget.FormGuide.prototype.getPrevName = function(name) {
    var index = this._names.indexOf(name);
    if (index > 0) {
        return this._names[index - 1];
    }
    return null;
};


/******************
 * Form Error-handling
 ******************/
el8.uiwidget.FormGuide.prototype.showErrorPage = function(name) {
    // If error page already initialized
    if ($('.form-guide-error', this._formContainer).length) {
        this.hideAll();
        $('.form-guide-error', this._formContainer).show();

    // Initialize the error page
    } else {
        var that = this;
        this.hideAll();
        this._formContainer.append(el8.template.uiwidget.FormGuide.errorPage());
        if (this._errorContentFn) {
            $('.form-guide-error-content', this._formContainer)
                .html(this._errorContentFn());
        }
        $('.form-guide-error', this._formContainer)
            .on('click', '.restart-trigger',  function() {
                that.moveTo(that._names[0], true, true);
            });
    }
};
